module.exports = __webpack_public_path__ + "img/pos1-bg.b6b757a1.jpg";